/* eslint-disable @typescript-eslint/no-explicit-any */
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function NCMInfo({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex flex-col gap-4">
      <Label className="text-lg">{label}</Label>
      <Input value={value} disabled className="bg-gray-100 h-12 text-lg" />
    </div>
  );
}
